import React from 'react';
import { cn } from '@/lib/utils';

export const categories = [
  { value: "all", label: "All Services", icon: "Globe" },
  { value: "software", label: "Software", icon: "Code2" },
  { value: "ai", label: "AI & Automation", icon: "Bot" },
  { value: "virtualAssistance", label: "AI Assistants", icon: "Brain" },
  { value: "seoai", label: "SEO & Marketing", icon: "TrendingUp" },
  { value: "creatives", label: "Creative", icon: "Palette" },
  { value: "architecture", label: "Architecture", icon: "Building2" },
];

export const getCategoryLabel = (value: string) =>
  categories.find(c => c.value === value)?.label ?? value;

interface ServiceCategoriesProps {
  activeCategory: string;
  setActiveCategory: (category: string) => void;
  counts?: Record<string, number>;
}

const ServiceCategories = ({ activeCategory, setActiveCategory, counts }: ServiceCategoriesProps) => (
  // Scrolls sideways inside itself on narrow screens instead of widening the page.
  <div className="-mx-4 overflow-x-auto px-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
    <div role="tablist" aria-label="Filter services" className="flex w-max gap-2">
      {categories.map(category => {
        const active = activeCategory === category.value;
        const count = counts?.[category.value];
        return (
          <button
            key={category.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => setActiveCategory(category.value)}
            className={cn(
              'inline-flex items-center gap-2 whitespace-nowrap rounded-full border px-4 py-2 text-sm font-medium transition-all duration-200',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background',
              active
                ? 'border-primary bg-primary text-white shadow-lg shadow-primary/25'
                : 'border-slate-200 bg-white/70 text-slate-700 hover:border-primary/40 hover:text-primary dark:border-white/10 dark:bg-white/[0.04] dark:text-slate-300'
            )}
          >
            {category.label}
            {count !== undefined && (
              <span className={cn(
                'rounded-full px-1.5 text-xs tabular-nums',
                active ? 'bg-white/20' : 'bg-slate-100 text-slate-500 dark:bg-white/10 dark:text-slate-400'
              )}>
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  </div>
);

export default ServiceCategories;
